import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tokenState } from "../state";
import { useSearchSegemnet } from "hooks/useSearchSegment";
// import { amplitude } from "utils/analytics";

const PageTracker = () => {
  const { searchParams, trackSearchResult } = useSearchSegemnet();
  const { key, pathname, search } = useLocation();
  const [token] = useRecoilState(tokenState);
  const [prevPath, setPrevPath] = useState<{
    path: string;
    searchKeyword?: string | null;
    indexUid?: string | null;
  }>({
    path: "",
  });

  const segment = window.analytics;

  useEffect(() => {
    if (token && token.uid) {
      segment?.identify(token.uid, {
        type: token.user_type,
        name: token.user_name,
        userGroup: token.is_owner === 1 ? "owner" : token.user_type,
      });

      // GA4 user_id 설정 - gtag이 로드될 때까지 대기
      const setGtagUserId = () => {
        if (window.gtag) {
          window.gtag("set", "user_id", token.sub);
          window.gtag("set", "user_properties", { ssoId: token.sub });
          // config 재호출로 user_id를 현재 세션에 바인딩 (send_page_view: false로 중복 page_view 방지)
          window.gtag("config", import.meta.env.VITE_APP_GTAG_KEY, {
            user_id: token.sub,
            send_page_view: false,
          });
          localStorage.setItem("_moreden_ga_uid", token.sub);
        } else {
          // gtag이 아직 로드되지 않았으면 100ms 후 재시도
          setTimeout(setGtagUserId, 100);
        }
      };
      setGtagUserId();

      // amplitude는 pageView auto tracking
      // amplitude?.setUserId(token.uid);
    }
  }, [token]);

  useEffect(() => {
    trackSearchResult(pathname, prevPath);
    // Segment
    segment?.page(/* category */ "", /* name */ "", {
      // name: "",
      path: pathname,
      // referrer: "",
      search: search || undefined,
      title: document.title,
      url: window.location.href,
      // keywords: ""
    });

    setPrevPath({
      path: pathname,
      searchKeyword: searchParams.get("q"),
      indexUid: searchParams.get("indexUid"),
    });
    // Amplitude
  }, [key]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default PageTracker;
